import { any2unix } from '../../utils/unixtime';
export function setPeriod(mintime, maxtime, reload_anyway) {
    return (dispatch, getState) => {
        const current_period = getState().period;
        if (current_period != null) {
            if (!reload_anyway &&
                current_period.mintime == mintime &&
                current_period.maxtime == maxtime) {
                return;
            }
        }
        dispatch({
            type: 'SET_PERIOD_ACTION',
            mintime: any2unix(mintime),
            maxtime: any2unix(maxtime),
        });
    };
}
